export default __webpack_public_path__ + "static/media/Instruction1-2025.086293ad.png";